import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getGettingStartedStatus } from "../../helpers/backend_helper";
import { getAuthenticatedUser } from "../../helpers/auth-session";

export default function PostLoginLanding() {
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;

    const chooseDestination = async () => {
      if (Number(getAuthenticatedUser()?.firmId) === 1) {
        if (active) navigate("/dashboard", { replace: true });
        return;
      }
      let destination = "/review-tasks";
      try {
        const response = await getGettingStartedStatus();
        const role = response?.status
          ? response.data?.roleName?.trim().toLowerCase()
          : "";
        if (
          [
            "admin", "administrator", "system admin", "system administrator",
            "piers admin", "piers administrator", "firm admin", "firm administrator",
            "account/firm admin", "account/firm administrator",
          ].includes(role)
        ) {
          destination = response.data?.isApplicable && !response.data.preference?.tourCompleted
            ? "/piers/getting-started"
            : "/inspections/overview";
        }
      } catch {
        /* My Work remains available if setup status cannot be loaded. */
      }
      if (active) navigate(destination, { replace: true });
    };
    chooseDestination();
    return () => {
      active = false;
    };
  }, [navigate]);

  return (
    <main role="status" aria-live="polite">
      Opening PIERS…
    </main>
  );
}
